import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function displaySwitchOption(theme: Theme): ComponentStyle {
  return {
    componentName: 'displaySwitchOption',
    baseStyle: {
      cursor: 'pointer',
      position: 'relative',
      whiteSpace: 'nowrap',
      borderRadius: 'unset',
      color: theme.colors.muted,
      padding: `${theme.space['xs']} ${theme.space['s']}`,
      fontSize: theme.sizes[0],

      ['&:hover']: {
        backgroundColor: 'transparent'
      },

      ['&:after']: {
        content: '""',
        position: 'absolute',
        inset: 0,
        zIndex: -1,
        mixBlendMode: 'overlay',
        border: `solid 1px ${theme.colors.white70}`
      },

      ['&:hover:after']: {
        background: theme.colors.white25
      },

      ['&:first-child:after']: {
        borderTopLeftRadius: theme.sizes[-1],
        borderBottomLeftRadius: theme.sizes[-1]
      },

      ['&:last-child:after']: {
        borderTopRightRadius: theme.sizes[-1],
        borderBottomRightRadius: theme.sizes[-1]
      }
    },
    states: {
      active: {
        color: theme.colors.text,
        backgroundColor: 'transparent',

        ['&:after']: {
          backgroundColor: theme.colors.white70
        },

        ['&:hover']: {
          backgroundColor: 'transparent'
        }
      }
    }
  };
}
